import { FC, useCallback, useState } from 'react';
import { Button } from '@mui/material';
import ModalDialog from '../../common/components/ModalDialog';
import EditBusinessPriorityContent from '../components/EditBusinessPriority/EditBusinessPriorityContent';
import { setBusinessPriority } from '../actions/applications-actions';

const EditPriorityModalContainer: FC<
  React.PropsWithChildren<EditPriorityModalContainerProps>
> = ({ open, setOpen }) => {
  const onClose = useCallback(() => setOpen(false), [setOpen]);
  const [value, setValue] = useState(0);
  const onChange = useCallback((event: Event, newValue: number | number[]) => {
    setValue(newValue as number);
  }, []);
  const onSubmit = useCallback(() => {
    setBusinessPriority(value);
    onClose();
  }, [value, onClose]);

  return (
    <ModalDialog
      onClose={onClose}
      modalHeader='Change Business Priority'
      open={open}
      modalFooter={
        <>
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={onSubmit}>Change Business Priority</Button>
        </>
      }>
      <EditBusinessPriorityContent value={value} onChange={onChange} />
    </ModalDialog>
  );
};

export interface EditPriorityModalContainerProps {
  open: boolean;
  setOpen: (value: boolean) => void;
}

export default EditPriorityModalContainer;
